import React from 'react';
import './styles.scss';
import {ReactComponent as Logo} from './../img/group-4-copy.svg';
import { useHistory } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';



const PageNotFound = () => {

  const history = useHistory();

  return (
    <div className="NotFound justify-content-center">
      <h3 className="pt-9"><b>{I18n.t('notFound.ups')}</b></h3>
      <h5 className="pt-4 pb-5">{I18n.t('notFound.doesntExist')} <b>{I18n.t('notFound.itsYours')}</b></h5>
      <Logo/>
      <h5 className="pt-4 pb-4"><b>{I18n.t('notFound.meanwhile')}</b></h5>
      <button className="buttonStyle btn-success" onClick={()=>history.push("/")} ><b>{I18n.t('notFound.buttonMessage')}</b></button>
    </div>
    )

};


export default PageNotFound;
